import React from "react";
import { View, StyleSheet, Dimensions } from "react-native";

const IframeScreen = ({ route }) => {
  const { url } = route.params;

  return (
    <View style={{ flex: 1, width: "100%", height: "100%" }}>
      <iframe
        src={url}
        style={{
          width: "100%",
          height: "100%",
          border: "none",
          marginTop: "54px",
        }}
        title="Iframe"
      />
    </View>
  );
};

export default IframeScreen;
